<div class="d-flex card" *ngIf="!menuItemSelected">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">Menu Items</div>
	</div>
	<p-divider></p-divider>

	<p-table
		#dt
		styleClass="p-datatable-responsive-demo"
		[value]="venueService.ooMenuItems"
		[loading]="!venueService.ooMenuItems"
		[globalFilterFields]="app.keys(venueService.ooMenuItems)"
		[rowHover]="true"
		[rows]="10"
		[showCurrentPageReport]="true"
		[rowsPerPageOptions]="[10, 25, 50]"
		responsiveLayout="scroll"
		[paginator]="true"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} items"
	>
		<ng-template pTemplate="caption">
			<div class="table-header d-flex">
				<div class="flex-grow-1">
					<span class="p-float-label p-input-icon-left m-2 w-100">
						<i class="pi pi-search"></i>
						<input
							pInputText
							class="w-100"
							id="globalSearch"
							name="globalSearch"
							style="width: 100%"
							type="text"
							(input)="dt.filterGlobal($event.target.value, 'contains')"
						/>
						<label for="globalSearch">Search...</label>
					</span>
				</div>
			</div>
		</ng-template>
		<ng-template pTemplate="header">
			<tr>
				<th pSortableColumn="name">
					Guest Check Name
					<p-sortIcon field="name"></p-sortIcon>
				</th>
				<th pSortableColumn="menuItemKey">
					Menu Item ID
					<p-sortIcon field="menuItemKey"></p-sortIcon>
				</th>
				<th pSortableColumn="outOfStock">
					Out Of Stock
					<p-sortIcon field="outOfStock"></p-sortIcon>
				</th>
				<th pSortableColumn="online">
					On Countdown
					<p-sortIcon field="countdown"></p-sortIcon>
				</th>
				<th pSortableColumn="lastUpdated">
					Last Updated
					<p-sortIcon field="lastUpdated"></p-sortIcon>
				</th>
			</tr>
		</ng-template>
		<ng-template let-rec pTemplate="body">
			<tr (click)="menuItemSelected = rec">
				<td>
					<span class="p-column-title">Name</span>
					{{ rec.name }}
				</td>
				<td pEditableColumn>
					<span class="p-column-title">Menu Item ID</span>
					{{ rec.menuItemKey }} - {{ rec.menuItemId }}
				</td>
				<td>
					<span class="p-column-title">Out of Stock</span>
					<p-inputSwitch [(ngModel)]="rec.outOfStock" [disabled]="true"></p-inputSwitch>
				</td>
				<td>
					<span class="p-column-title">Countdown</span>
					<p-inputSwitch [(ngModel)]="rec.countdown" [disabled]="true"></p-inputSwitch>
				</td>
				<td>
					<span class="p-column-title">Last Updated</span>
					<span *ngIf="rec.lastUpdated">
						{{ moment(rec.lastUpdated).format('l LT') }}
					</span>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<app-menu-item-record-setup
	*ngIf="menuItemSelected"
	[menuItemKey]="menuItemSelected.menuItemKey"
	(onMenuItemCanvasClearEmitter)="menuItemSelected = undefined"
></app-menu-item-record-setup>
